import { createSelector } from '@ngrx/store';
import { AppState } from './app.state';

export const selectAppVersion = createSelector(
  (state: AppState) => state.app,
  appState => appState.appVersion
);
